import { createContext, useEffect, useState } from 'react';
import { t } from '@lingui/core/macro';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { useApprovalWorkflow } from 'app/domains/approval';
import { DocumentDrawerHeader, useActiveDocument } from 'shared/domains/documents';
import { DocumentActionsDropdown } from './DocumentActionsDropdown';
import { SettingsList } from './SettingsList';
import { getComponent } from './utils';
import { DrawerContainer, ListContainer } from './styled';
import { DocumentSettingsKeys } from './types';
export const SettingsDrawerContext = createContext(null);
export function SettingsDrawer(props) {
    const { onClose } = props;
    const { pathname } = useLocation();
    const history = useHistory();
    const { url } = useRouteMatch();
    const { approvalWorkflowAvailable } = useApprovalWorkflow();
    const { id } = useActiveDocument();
    const controlledSettingKey = DocumentSettingsKeys.filter((settingKey) => approvalWorkflowAvailable ? true : settingKey !== 'approval').find((settingKey) => pathname.includes(settingKey));
    const [activeSetting, setActiveSetting] = useState(controlledSettingKey || null);
    useEffect(() => {
        if (controlledSettingKey && controlledSettingKey !== activeSetting) {
            setActiveSetting(controlledSettingKey);
        }
    }, [pathname, controlledSettingKey, activeSetting]);
    const handleClose = () => {
        history.replace(url);
        onClose();
    };
    const handleGoBack = () => {
        history.replace(url);
        setActiveSetting(null);
    };
    const Component = getComponent(activeSetting);
    if (Component) {
        return <Component onGoBack={handleGoBack} onClose={handleClose}/>;
    }
    const value = {
        onSelectSetting: setActiveSetting,
    };
    const title = t({
        comment: 'Document settings drawer - title',
        message: 'Document',
    });
    return (<SettingsDrawerContext.Provider value={value}>
      <DrawerContainer>
        <DocumentDrawerHeader type="root" title={title} onClose={handleClose} actions={<DocumentActionsDropdown documentId={id}/>}/>
        <ListContainer>
          <SettingsList />
        </ListContainer>
      </DrawerContainer>
    </SettingsDrawerContext.Provider>);
}
